import React, { useId, useRef, useMemo } from 'react';
import classnames from 'classnames';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';

const Avatar = ({ label, name, value, readOnly, onChange, className }) => {
	// Generate random id once
	const id = useId();

	// Create input's ref
	const input = useRef(null);

	// Container's classnames
	const containerClassName = classnames(
		'flex flex-col',
		className
	);

	// Input's classnames
	const elementClassName = classnames(
		'px-3 h-9 w-full bg-transparent border border-neutral-200 dark:border-neutral-700 dark:text-white text-neutral-800 placeholder:text-neutral-400 rounded-lg focus:border-transparent focus:ring focus:ring-amber-500 read-only:cursor-not-allowed read-only:focus:ring-0 transition-all',
	);

	// Handle input's value change
	const handle = (event) => {
		onChange({
			name,
			value: event.target.files[0] ?? ''
		});
	};

	// Handle input's value clear
	const remove = () => {
		onChange({
			name,
			value: ''
		});

		// Reset input's value
		input.current.value = '';
	};

	// Create preview from value
	const preview = useMemo(() => {
		if (typeof value === 'string' && value !== '') {
			// eslint-disable-next-line
			return `${process.env.REACT_APP_CDN}/avatars/${value}`;
		} else {
			return value ? URL.createObjectURL(value) : '';
		}
	}, [value]);

	return (
		<div className={containerClassName}>
			{/* Show label only if passed */}
			<Show if={label}>
				<label
					htmlFor={id}
					className="mb-2 text-sm font-bold text-neutral-800 dark:text-white transition-colors"
				>
					{label}
				</label>
			</Show>

			{/* Preview */}
			<div className="">
				{/* Show selected image */}
				<Show if={preview}>
					<div className="w-20 h-20 rounded-full overflow-hidden" onClick={remove}>
						<img src={preview} alt="Attēls" className="object-cover w-full h-full" />
					</div>
				</Show>

				{/* Show placeholder */}
				<Show if={!preview}>
					<label htmlFor={id} className="w-20 h-20 flex justify-center items-center rounded-full text-neutral-400 bg-neutral-100 dark:bg-neutral-700 transition-colors cursor-pointer">
						<Icon icon="person" className="text-5xl" />
					</label>
				</Show>
			</div>

			{/* Hidden file input */}
			<input
				id={id}
				ref={input}
				type="file"
				name={name}
				onChange={handle}
				readOnly={readOnly}
				className="hidden"
				accept="image/*"
			/>
		</div>
	);
};

export default Avatar;